import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'app/store';
import { fetchAuthLinksEffect } from 'app/store/Auth/effects.utils';
import {
  getApiKeyWebSelector,
  getBootstrapLoadingState,
} from 'app/store/Auth/selectors';
import { LoadingState } from 'types/enums';
import { Outlet } from 'react-router-dom';
import { ChakraAppLoader } from 'app/components/Core';

export const WebWrapper = () => {
  const dispatch = useAppDispatch();
  const bootstrapLoadingState = useAppSelector(getBootstrapLoadingState);
  const apiKey = useAppSelector(getApiKeyWebSelector);

  const bootstrapLoading = [
    LoadingState.PRISTINE,
    LoadingState.FETCHING,
  ].includes(bootstrapLoadingState);
  const bootstrapFetched = bootstrapLoadingState === LoadingState.FETCHED;
  const bootstrapError = bootstrapLoadingState === LoadingState.ERROR;

  useEffect(() => {
    dispatch(fetchAuthLinksEffect());
  }, [dispatch]);

  return (
    <>
      {(bootstrapLoading || !apiKey) && <ChakraAppLoader />}
      {(bootstrapFetched || bootstrapError) && <Outlet />}
    </>
  );
};
